module.exports = __webpack_public_path__ + "img/syukyaku-de-pa002.6a2a586f.png";